// extracted by mini-css-extract-plugin
export default {"companyProfileCardsList":"CompanyProfileCardsList_companyProfileCardsList__27OYJ"};